<template>
  <div class="app-error">
    <section class="app-error__invalid">
      <h2>Sorry, there is an issue with your link.</h2>
      <p>Please contact us to verify your banking details.</p>
      <p>1-888-865-6402</p>
    </section>

    <section class="app-error__recommended">
      <h2>Recommended Product</h2>
      <p>Improve Your Financial Wellbeing</p>
      <p>Get Your Credit Report for Free with Borrowell</p>
    </section>

    <a
      href="//cdrv.es/3hh"
      target="_blank"
      rel="nofollow"
    >
      <AppButton
        v-data-layer
        data-layer="finished_borrowell_apply"
      >
        Get Your Free Credit Score
      </AppButton>
    </a>
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButtonContinue'
import DataLayer from '@/data-layer'

export default {
  name: 'LinkIssue',

  components: {
    AppButton
  },

  created () {
    DataLayer.pushObject({
      event: 'bank_verification_failed',
      appid: this.$route.query.appid
    })
  }
}
</script>

<style lang="scss" scoped>
.app-error {
  text-align: center;
  margin-bottom: 130px;
  color: $brand-color-black;

  @include breakpoint('tablet-portrait-up') {
    margin-bottom: 240px;
  }

  h2 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;

    @include breakpoint('tablet-portrait-up') {
      font-size: 25px;
      margin-bottom: 25px;
    }

    @include breakpoint('desktop-up') {
      font-size: 35px;
    }
  }

  p {
    font-size: 14px;
    width: 250px;
    margin: auto;
    margin-bottom: 25px;

    @include breakpoint('tablet-portrait-up') {
      font-size: 20px;
      margin-bottom: 35px;
      width: 100%;
    }

    @include breakpoint('desktop-up') {
      margin-bottom: 40px;
    }
  }

  // link invalid message
  &__invalid {
    margin: 26.5px auto 55px;

    @include breakpoint('tablet-portrait-up') {
      margin-top: 48.5px;
      margin-bottom: 85px;
    }

    @include breakpoint('desktop-up') {
      margin-top: 63.5px;
      margin-bottom: 85px;
    }
  }

  // apply now button
  .app-button-continue {
    padding: 11px 0;
    max-width: 280px;

    @include breakpoint('tablet-portrait-up') {
      padding: 12px 0;
      max-width: 385px;
    }
  }
}
</style>
